import { NgModule } from '@angular/core';
import { provideRouter, RouterModule, Routes, withComponentInputBinding } from '@angular/router';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { DynamicModule } from 'ng-dynamic-component';
import { FormsModule } from "@angular/forms";

import { AuthGuard } from "src/index/services.index";
import { LocalizationModule, SharedModule } from 'src/core/index/shared.module.index';
import {
  LiquidViewerComponent,
  LiquidToolbarComponent,
  LiquidToolbarPanelComponent,
  LiquidIndexComponent,
  LiquidSettingsComponent,
  LiquidInfoComponent,
  LiquidAnnotationsListComponent,
} from 'src/index/components.index';
import {
  LiquidPageModule
} from 'src/index';

const routes: Routes = [
  {
    path: 'liquid-viewer/:id',
    canActivate: [AuthGuard],
    component: LiquidViewerComponent,
  },
  {
    path: 'liquid-viewer/:id/:contentId',
    canActivate: [AuthGuard],
    component: LiquidViewerComponent,
  },
  {
    path: 'liquid-viewer/:id/:secondaryId/:contentId',
    canActivate: [AuthGuard],
    component: LiquidViewerComponent,
  },
];

@NgModule({
  declarations: [
    LiquidViewerComponent,
    LiquidToolbarComponent,
    LiquidToolbarPanelComponent,
    LiquidIndexComponent,
    LiquidSettingsComponent,
    LiquidInfoComponent,
    LiquidAnnotationsListComponent,
  ],
  imports: [
    BrowserModule,
    CommonModule,
    DynamicModule,
    FormsModule,
    LocalizationModule,
    RouterModule,
    SharedModule,
    LiquidPageModule,
  ],
  providers: [
    AuthGuard,
    provideRouter(routes, withComponentInputBinding()),
  ],
  exports: [
    LiquidViewerComponent,
    LiquidToolbarComponent,
    LiquidToolbarPanelComponent,
    LiquidIndexComponent,
    LiquidSettingsComponent,
    LiquidInfoComponent,
    LiquidAnnotationsListComponent,
  ],
})
export class LiquidViewerModule {
  getRoutes() {
    return routes;
  }
}
